import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import {
  Checkbox,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AlertBox from "../../component/AlertBox";
import PaginationBar from "../../component/PaginationBar";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import { IoMdNotificationsOutline } from "react-icons/io";

function NotificationManagement() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.notificationSend === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState([]);
  const [reload, setReload] = useState(false);
  const [selectedEmployeesToken, setSelectedEmployeesToken] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [selectedSingleEmployee, setSelectedSingleEmployee] = useState("");

  // fetch member details
  async function getEmployees() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/all/employees/${page}?search=${search}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTotalPage(res.data?.data?.totalPages);
      setEmployeeData(res.data?.data?.data);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Employees fetch failed");
    } finally {
      setLoading(false);
    }
  }

  async function sendNotiToSingleEmployee() {
    if (title.trim() === "" || body.trim() === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Title and body are required");
      return null;
    }
    try {
      setLoading(true);
      const data = {
        userId: selectedSingleEmployee,
        title: title,
        body: body,
      };
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/notification/send/single/employee`,
        method: "post",
        data: data,
        withCredentials: true,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Notification has been send");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Notification sent failed");
    } finally {
      setLoading(false);
      setSelectedSingleEmployee("");
      setTitle("");
      setBody("");
    }
  }

  async function sendNotiToSelectedEmployee() {
    if (title.trim() === "" || body.trim() === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Title and body are required");
      return null;
    }
    try {
      setLoading(true);
      const data = {
        tokenArray: selectedEmployeesToken,
        title: title,
        body: body,
      };
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/notification/send/bulk/selected/employee`,
        method: "post",
        data: data,
        withCredentials: true,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Notification has been send");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Notification sent failed");
    } finally {
      setLoading(false);
      setSelectedSingleEmployee("");
      setTitle("");
      setBody("");
    }
  }

  async function sendNotiToAllEmployee() {
    if (title.trim() === "" || body.trim() === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Title and body are required");
      return null;
    }
    try {
      setLoading(true);
      const data = {
        tokenArray: selectedEmployeesToken,
        title: title,
        body: body,
      };
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/notification/send/bulk/all/employees`,
        method: "post",
        data: data,
        withCredentials: true,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Notification has been send");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Notification sent failed");
    } finally {
      setLoading(false);
      setSelectedSingleEmployee("");
      setTitle("");
      setBody("");
    }
  }

  const changeSelectedEmployeeToken = (status, userToken) => {
    console.log(status);
    if (status) {
      setSelectedEmployeesToken((prev) => {
        let newArr = [...prev, userToken];
        return newArr;
      });
    } else {
      setSelectedEmployeesToken((prev) => {
        let editedArr = prev.filter((token) => token !== userToken);
        return editedArr;
      });
    }
  };

  useEffect(() => {
    getEmployees();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Notifcation Center
          </h1>
          <div className="mt-5 w-full">
            <div className="w-full flex justify-end items-center gap-3">
              <DialogBox
                trigger={
                  <ButtonCompo
                    variant={"contained"}
                    startIcon={<IoMdNotificationsOutline />}
                  >
                    Send To All
                  </ButtonCompo>
                }
                title={`Send Notification to All Employees`}
                actionButton={
                  <ButtonCompo onClick={sendNotiToAllEmployee}>
                    Send
                  </ButtonCompo>
                }
                closeActionButton="Cancel"
              >
                <div className="space-y-3">
                  <InputField
                    label="Title"
                    onChange={(eve) => setTitle(eve?.target?.value)}
                  />
                  <InputField
                    label="Body"
                    onChange={(eve) => setBody(eve?.target?.value)}
                  />
                  <p className="text-slate-700">
                    <span className="font-medium">Note: </span>You can't edit it
                    later
                  </p>
                </div>
              </DialogBox>
              <div className="flex justify-end gap-3">
                <TextField
                  label="Search"
                  size="small"
                  onChange={(eve) => setSearch(eve?.target?.value)}
                />
                <ButtonCompo
                  variant={"contained"}
                  onClick={() => setReload((prev) => !prev)}
                >
                  Search
                </ButtonCompo>
              </div>
            </div>
            <div className="w-full mt-5">
              {selectedEmployeesToken.length > 0 && (
                <section className="bg-blue-50 mb-5 p-5 flex justify-between items-center">
                  <p className="text-blue-600 font-medium">
                    {selectedEmployeesToken.length > 1
                      ? `${selectedEmployeesToken.length} employees`
                      : "1 employee"}{" "}
                    selected
                    <span
                      className="ml-3 bg-slate-500 font-medium text-[15px] text-white px-3 py-1 rounded-lg shadow-xl cursor-pointer"
                      onClick={() => setSelectedEmployeesToken([])}
                    >
                      Clear All
                    </span>
                  </p>
                  <DialogBox
                    trigger={
                      <ButtonCompo
                        variant={"contained"}
                        startIcon={<IoMdNotificationsOutline />}
                      >
                        Send Notification
                      </ButtonCompo>
                    }
                    title={`Send Notification to ${
                      selectedEmployeesToken.length > 1
                        ? `${selectedEmployeesToken.length} employees`
                        : "1 employee"
                    } `}
                    actionButton={
                      <ButtonCompo onClick={sendNotiToSelectedEmployee}>
                        Send
                      </ButtonCompo>
                    }
                    closeActionButton="Cancel"
                  >
                    <div className="space-y-3">
                      <InputField
                        label="Title"
                        onChange={(eve) => setTitle(eve?.target?.value)}
                      />
                      <InputField
                        label="Body"
                        onChange={(eve) => setBody(eve?.target?.value)}
                      />
                      <p className="text-slate-700">
                        <span className="font-medium">Note: </span>You can't
                        edit it later
                      </p>
                    </div>
                  </DialogBox>
                </section>
              )}
              <Table>
                <TableHead>
                  <TableRow className="bg-blue-500">
                    <TableCell className="!text-center !text-white !font-semibold">
                      Select
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Employee ID
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Name
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Email
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Phone Number
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Role
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Designation
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Notification
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="border">
                  {employeeData?.map((e, i) => (
                    <TableRow>
                      <TableCell className="!text-center !font-medium">
                        <Checkbox
                          disabled={e?.fcmToken !== undefined ? false : true}
                          checked={selectedEmployeesToken?.some(
                            (token) => token === e?.fcmToken
                          )}
                          onChange={(eve) =>
                            changeSelectedEmployeeToken(
                              eve?.target?.checked,
                              e?.fcmToken
                            )
                          }
                        />
                      </TableCell>
                      <TableCell className="!text-center !font-medium !text-blue-600">
                        <span className="bg-blue-200/40 px-3 py-2 rounded-full font-medium text-[13px]">
                          {e?.employeeId}
                        </span>
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.fullName}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.profEmail}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.phoneNumber}
                      </TableCell>
                      <TableCell className="!text-center">{e?.role}</TableCell>
                      <TableCell className="!text-center">
                        {e?.designation}
                      </TableCell>
                      <TableCell className="!text-center">
                        <DialogBox
                          trigger={
                            <ButtonCompo
                              variant={"contained"}
                              onClick={() => setSelectedSingleEmployee(e?._id)}
                              startIcon={<IoMdNotificationsOutline />}
                              disabled={
                                e?.fcmToken !== undefined ? false : true
                              }
                            >
                              Send
                            </ButtonCompo>
                          }
                          title={`Send Notification to ${e?.fullName}`}
                          actionButton={
                            <ButtonCompo onClick={sendNotiToSingleEmployee}>
                              Send
                            </ButtonCompo>
                          }
                          closeActionButton="Cancel"
                        >
                          <div className="space-y-3">
                            <InputField
                              label="Title"
                              onChange={(eve) => setTitle(eve?.target?.value)}
                            />
                            <InputField
                              label="Body"
                              onChange={(eve) => setBody(eve?.target?.value)}
                            />
                            <p className="text-slate-700">
                              <span className="font-medium">Note: </span>You
                              can't edit it later
                            </p>
                          </div>
                        </DialogBox>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <PaginationBar
                attendancePage={page}
                setAttendancePage={setPage}
                totalAttendancePage={totalPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotificationManagement;
